import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionsService } from '@customer/services';
import { GuardContextService } from '@core/services';

// eslint-disable-next-line local/boolean-method-naming
export const externalAdmin: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const guardContextSvc = inject(GuardContextService);
  if (guardContextSvc.context?.doContinuation === false) {
    delete guardContextSvc.context;
    return false;
  }
  const permissionsSvc = inject(PermissionsService);
  const permissionChecks = ['hasExternalAdminRole', 'hasPortalEmployeeRole', 'hasMeasurementEmployeeRole'] as const;
  const _isPermitted: boolean = permissionChecks.some(rolesSvcFnName => permissionsSvc[rolesSvcFnName]() === true);
  const returnRoute = sessionStorage.getItem('_returnRoute')?.split(window.location.origin).at(1);
  sessionStorage.removeItem('_returnRoute');
  if (!_isPermitted) {
    const navigationExtras = returnRoute
      ? {
          state: {
            viaCanMatch: true,
            type: 'external-admin'
          }
        }
      : undefined;
    inject(Router).navigate([window.sessionStorage.getItem('routeHome')], navigationExtras);
  }
  return _isPermitted;
};
